import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';

// material-ui
import { Grid, Typography, Alert, AlertTitle } from '@mui/material';

// third party
import { format } from 'date-fns';
import { useIntl } from 'react-intl';

// project imports
import { useDispatch } from 'store';
import { openSnackbar } from 'store/slices/snackbar';
import { ApiNotificationsDeleteItem } from 'store/app/admin/notification';

// project hooks
import useIntersectionObserver from 'hooks/useIntersectionObserver';

// ==============================|| NOTIFICATION CARD ||============================== //

const NotificationCard = ({ notification = {}, rowIndex = 0, baseKey = '', handleOnRead = () => {} }) => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const notCardRef = useRef(null);
    const isBeingObserved = useIntersectionObserver(notCardRef);

    useEffect(() => {
        if (isBeingObserved && !notification?.viewedAt) {
            handleOnRead(notification?.id);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isBeingObserved, notification]);

    return (
        <Alert
            ref={notCardRef}
            key={`${baseKey}-card-${rowIndex}`}
            severity={notification?.severity || 'info'}
            variant="filled"
            closeText={intl.formatMessage({ id: 'ui-comp-button-delete' })}
            onClose={() =>
                ApiNotificationsDeleteItem({
                    id: notification?.id,
                    errorCallback: (error) =>
                        dispatch(
                            openSnackbar({
                                open: true,
                                message: error || intl.formatMessage({ id: 'ui-comp-snackbar-genericerror-text' }),
                                variant: 'alert',
                                alert: { color: 'error' }
                            })
                        )
                })
            }
        >
            <AlertTitle>
                <Grid container>
                    <Grid item xs>
                        {notification?.name || ''}
                    </Grid>
                    {notification?.createdAt && (
                        <Grid item xs={4}>
                            <Typography display="block" gutterBottom>
                                {format(new Date(notification.createdAt), 'd/MM/yyyy')}
                            </Typography>
                        </Grid>
                    )}
                </Grid>
            </AlertTitle>
            {notification?.description || ''}
        </Alert>
    );
};

NotificationCard.propTypes = {
    notification: PropTypes.object,
    rowIndex: PropTypes.number,
    baseKey: PropTypes.string,
    handleOnRead: PropTypes.func
};

export default NotificationCard;
